/* eslint-disable arrow-body-style */
import gsap from 'gsap';

const poiFinalRobot = {
  schema: {
  },

  init() {
    this.el.addEventListener('click', () => {
      if (this.alreadyInteracted || this.el.poiIsLocked) return;
      // this.alreadyInteracted = true;
      this.el.sceneEl.emit('showMessage', {
        title: 'Robot',
        message: [
          "command_robot_1",
          "command_robot_2",
          "command_robot_3"
        ],
        callback: () => {
          this.playAnimation();
        }
      }, false);
    });
  },

  playAnimation() {
    /*gsap.to(this.el.object3D.position, {
      duration: 1.0,
      z: '+=4.2',
      ease: 'sine.inOut',
    });*/
  },
};

export default poiFinalRobot;
